export const ACTOR = {
  USER: 'USER',
  AGENT: 'AGENT'
};